<template>
  <div class="calendar daily-calendar">
    <div class="calendar-header">
      <div
        v-show="isBookingSystem"
        class="dayoff"
        :class="presentDayOffClass"
        @click="handleClickBlocking(dates[0])"
      >
        예약 차단
        <div class="dayoff-icon" />
      </div>
    </div>
    <div
      v-bar
      v-loading="loading"
      class="calendar-body"
    >
      <div>
        <ScheduleCalandarTimeline />
        <div class="calendar-schedule">
          <DailyScheduleContainer
            type="daily"
            :date="dates[0]"
            :schedules="childCourse"
            @select="onSelectScheduleItem"
            @clickTime="onClickTime"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DailyScheduleContainer from "./DailyScheduleContainer";
import ScheduleCalandarTimeline from "./ScheduleCalandarTimeline";
import dateFns from "date-fns";

export default {
	name: "ScheduleCalandarByDaily",
	components: {
		ScheduleCalandarTimeline,
		DailyScheduleContainer,
	},
	props: ["dates", "blockings", "loading"],
	computed: {
		childCourse() {
      return this.$store.getters.getChildCoursesWithOverlapsByDates(this.dates)[0];
		},
		blocking() {
			return this.$store.getters.getBlockingsByDates(this.dates)[0];
		},
		presentDayOffClass() {
			return {
				"has-dayoff": this.blocking.length > 0,
			};
		},
		isBookingSystem() {
			return this.$store.getters.getIsBookingSystem;
		},
	},
	mounted() {
		this.moveScrollToCurrentTime();
	},
	methods: {
		moveScrollToCurrentTime() {
			const elVbar = document.querySelector(".vb-content");
			const curHour = dateFns.getHours(new Date());

			if (curHour < 6 && curHour > 1) {
				return;
			}

			elVbar.scrollTop = ((curHour - 8) / 18) * elVbar.scrollHeight;
		},
		onSelectScheduleItem(value) {
			this.$emit("select", value);
		},
		onClickTime(value) {
			this.$emit("clickTime", value);
		},
		handleClickBlocking(date) {
			if (this.blocking.length === 0) {
				return this.$emit("clickBlocking", {
					start: date,
				});
			}

			return this.$emit("clickBlocking", this.blocking[0]);
		},
	},
};
</script>

<style lang="scss">
.calendar {
	height: 100%;
	position: relative;
	margin-bottom: 70px;
}

.dayoff-icon {
	width: 15px;
	height: 15px;
	background-position: center;
	background-repeat: no-repeat;
	background-color: transparent;
	background-image: url(/image/icon/block/block-icon-unselected-daily.svg);
}

.calendar-header {
	margin-left: 80px;
	width: calc(100% - 80px);
	height: 45px;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	background-color: rgba(200, 200, 200, 0.5);
	text-align: right;
	position: relative;

	@media screen and (max-width: 768px) {
		margin-left: 60px;
		width: calc(100% - 60px);
		height: 40px;
	}
}

.calendar-body {
	width: 100%;
	height: calc(100% - 45px);
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	background-color: white;
	box-shadow: 0px 2px 8px rgba(220, 220, 220, 0.5);
}

.calendar-row-header {
	width: 80px;
	display: inline-block;

	@media screen and (max-width: 768px) {
		width: 60px;
	}
}

.calendar-schedule {
	position: relative;
	width: calc(100% - 80px);
	display: inline-block;
}

.daily-calendar {
	.dayoff {
		position: absolute;
		top: 0;
		right: 0;
		font-size: 15px;
		line-height: 46px;
		height: 45px;
		letter-spacing: -0.6px;
		color: #b9b9b9;
		cursor: pointer;
		padding-right: 38px;

		.dayoff-icon {
			position: absolute;
			top: 15px;
			right: 15px;
		}

		&:hover {
			color: #9b9b9b;
			.dayoff-icon {
				background-image: url("/image/icon/icon/dayoff/hover.svg");
			}
		}

		&.has-dayoff {
			color: #4a4a4a;

			.dayoff-icon {
				background-image: url("/image/icon/icon/dayoff/on.svg");
			}
		}

		@media screen and (max-width: 768px) {
			font-size: 13px;
			line-height: 40px;
			height: 40px;

			.dayoff-icon {
				top: 12px;
				right: 15px;
			}
		}
	}
}
</style>
